import type { FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';

export const VaultCardLeftBody = (props: FlexProps) => {
  const { children, ...flexProps } = props;
  return (
    <Flex flexDir="column" bg="#42246D" w="full" pt={2} px={4} {...flexProps}>
      {children}
    </Flex>
  );
};
